<top-banner variant="title" [title]="site?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu *ngIf="!asset" [site]="this.site"></app-site-tab-menu>
            <app-site-tab-menu *ngIf="asset" [site]="this.site"[optTitle]="{ from: asset.id, to: asset.name }"></app-site-tab-menu>
          </div>

          <div class="col-md-10">
            <div *ngIf="!asset" class="progress-spinner-wrapper">
              <p-progressSpinner></p-progressSpinner>
            </div>
            <ng-container *ngIf="asset">
              <div class="asset-page-header">
                <div class="asset-title-and-types">
                  <h3 class="card-section-header">
                    <span class="mr-4"><i class="fas fa-pen-to-square"></i> </span> {{ asset.name }}
                  </h3>
                  <ng-container *ngFor="let cat of asset.assetCategories">
                    <span class="badge badge-pill" [ngClass]="'badge-primary'" [style.background-color]="cat.color">{{ cat.name }}</span>
                  </ng-container>
                </div>
                <div class="asset-image-wrapper">
                  <img [src]="imageUrl" />
                </div>
              </div>
              <div *ngIf="asset" class="mb-2 animated fadeIn">
                <p>
                  {{ asset.description }}
                </p>
                <div class="button-link-wrapper">
                  <button type="button" class="btn btn-primary btn-link" (click)="editAssetDetails()">edit</button>
                  <button type="button" class="btn btn-danger btn-link" (click)="deleteAsset()">delete</button>
                </div>
                <dl class="sideways-dl mb-3">
                  <div>
                    <dt>Latitude</dt>
                    <dd>{{ asset.latitude !== undefined && asset.latitude !== null ? asset.latitude : 'N/A' }}</dd>
                  </div>
                  <div>
                    <dt>Longitude</dt>
                    <dd>{{ asset.longitude !== undefined && asset.longitude !== null ? asset.longitude : 'N/A' }}</dd>
                  </div>
                </dl>
                <dl *ngIf="isTurbineAsset" class="sideways-dl mb-3">
                  <div>
                    <dt>Manufacturer</dt>
                    <dd>{{ asset.manufacturer || 'N/A' }}</dd>
                  </div>
                  <div>
                    <dt>Model</dt>
                    <dd>{{ asset.model || 'N/A' }}</dd>
                  </div>
                  <div>
                    <dt>Rating (kW)</dt>
                    <dd>{{ asset.rating || 'N/A' }}</dd>
                  </div>
                </dl>

                <div class="sl-accordion">
                  <sl-accordion-section title="Restrictions">
                    <p-table *ngIf="asset.restrictions.length" [value]="asset.restrictions" [autoLayout]="true">
                      <ng-template pTemplate="header">
                        <tr>
                          <th style="width:50%">Restriction Description</th>
                          <th>Type</th>
                          <th>Created By</th>
                          <th>Created Date</th>
                          <th>Last Modified By</th>
                          <th></th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-restriction>
                        <tr>
                          <td><p class="asset-restriction"><i class="fas fa-exclamation-triangle"></i>&nbsp;{{ restriction.description }}</p></td>
                          <td>
                            <span *ngIf="restriction.type === 'OPERATIONAL'" class="badge badge-pill badge-warning">Operational</span>
                            <span *ngIf="restriction.type === 'HEALTH_AND_SAFETY'" class="badge badge-pill badge-danger">Health & Safety</span>
                            <span *ngIf="restriction.type === 'GENERAL'" class="badge badge-pill badge-primary">General</span>
                          </td>
                          <td>{{ restriction.createdBy }}</td>
                          <td><date-friendly [value]="restriction.createdDate"></date-friendly></td>
                          <td>{{ restriction.lastModifiedBy }}</td>
                          <td><button type="button" class="btn btn-primary btn-link" (click)="removeRestriction(restriction.id)">remove</button></td>
                        </tr>
                      </ng-template>
                    </p-table>

                    <p *ngIf="!asset.restrictions.length">No restrictions</p>
                    <div class="button-link-wrapper">
                      <button type="button" class="btn btn-primary btn-link" (click)="addRestriction()">Add Asset Restriction</button>
                    </div>
                  </sl-accordion-section>
                  <div class="row text-center" style="padding: 0 0 50px 0;" *ngIf="allowAssetScheduling && exemptFromAssetScheduling">
                    <div class="col-md-12">
                      <div class="alert alert-secondary" role="alert">Asset exempt from schedule</div>
                    </div>
                  </div>
                  <div class="widescreen-inline">
                    <sl-accordion-section title="Lock status">
                      <ng-container *ngIf="!asset.locked">
                        <p>
                          <i class="fas fa-unlock icon-side-margin color_green-shade1" title="Unlocked"></i>
                        </p>
                        <div class="button-link-wrapper">
                          <button type="button" class="btn btn-danger btn-link" (click)="alterLockStatus()">Lock asset</button>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="asset.locked && !asset.lockingWorkOrderId">
                        <p>
                          <i class="fas fa-lock icon-side-margin color_red-shade1" title="Locked"></i>
                        </p>
                        <div class="button-link-wrapper">
                          <button type="button" class="btn btn-danger btn-link" (click)="alterLockStatus()">Unlock asset</button>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="asset.locked && asset.lockingWorkOrderId">
                        <i class="fas fa-lock icon-side-margin color_red-shade1" title="Locked"></i>
                        <p class="color_red-shade1">Locked by a surrendered work order: WRK{{ asset.lockingWorkOrderId }}</p>
                        <div class="button-link-wrapper">
                          <button type="button" class="btn btn-primary btn-link" (click)="goToWorkOrder(asset.lockingWorkOrderId)">Go To Work Order</button>
                        </div>
                      </ng-container>
                    </sl-accordion-section>

                    <sl-accordion-section title="Certificates">
                      <ng-container *ngFor="let cert of asset.assetCertificates">
                        <span *ngIf="cert.expired" class="badge badge-pill badge-warning">{{ cert.title }} expired on: {{ cert.expiryDate | date : 'mediumDate' }}</span>
                        <span *ngIf="!cert.expired" class="badge badge-pill badge-success">{{ cert.title }} valid until: {{ cert.expiryDate | date : 'mediumDate' }}</span>
                      </ng-container>
                      <ng-container *ngIf="!asset.assetCertificates.length">
                        <p>No Certificates</p>
                      </ng-container>
                      <div class="button-link-wrapper">
                        <button type="button" class="btn btn-primary btn-link" (click)="editCertificates()">edit</button>
                      </div>
                    </sl-accordion-section>
                  </div>

                  <sl-accordion-section *ngIf="allowAssetScheduling && !exemptFromAssetScheduling" title="Schedule">
                    <div class="d-flex justify-content-center">
                      <button type="button" class="btn btn-success btn-round float-right" (click)="goToSchedulerPage()">Go To Site Schedule Page</button>
                    </div>
                    <br>
                    <br>
                    <div class="sl-accordion-content-overflow-wrapper">
                      <auto-table
                        [emptyMessage]="'No schedules created'"
                        [rows]="asset.assetAvailability"
                        [cols]="[
                          { field: 'startTime', header: 'Start Time', type: 'date', dateFormat: 'dd/MM/yy - EEEE - HH:mm' },
                          { field: 'endTime', header: 'End Time', type: 'date', dateFormat: 'dd/MM/yy - EEEE - HH:mm' },
                          { field: 'reason', header: 'Note' },
                          { field: 'link', header: '', type: 'link', linkText: 'edit' }
                        ]"
                        (onLinkClicked)="editScheduleItem($event)"
                      ></auto-table>
                    </div>
                    <div class="button-link-wrapper">
                      <button type="button" class="btn btn-primary btn-link" (click)="viewScheduleHistory()">view schedule history</button>
                    </div>
                    <button type="button" class="btn btn-success btn-round float-right" (click)="addScheduleItem()">Add</button>
                  </sl-accordion-section>

                  <sl-accordion-section title="Available Work Orders">
                    <div class="sl-accordion-content-overflow-wrapper">
                      <auto-table
                        [emptyMessage]="'No work orders available'"
                        [rows]="workOrders"
                        [cols]="[
                          { field: 'wrkId', header: 'WRK' },
                          { field: 'description', header: 'Description' },
                          { field: 'status', header: 'Status', type: 'work_order_status' },
                          { field: 'link', header: '', type: 'link', linkText: 'view' }
                        ]"
                        (onLinkClicked)="goToWorkOrder($event.id)"
                      ></auto-table>
                    </div>
                  </sl-accordion-section>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add a restriction -->
<p-dialog header="Add Asset Restriction" [(visible)]="isAddRestrictionModalShown" modal="true"  [style]="{'min-width': '600px'}" [dismissableMask]="true" [baseZIndex]="1000000">
  <form [formGroup]="addAssetRestrictionForm" (ngSubmit)="onAddRestrictionFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Restriction Description</label>
          <input type="text" class="form-control" formControlName="description" placeholder="restriction description" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Type<span class="required-star"> *</span></label>
          <p-dropdown class="form-control"
            formControlName="type"
            [options]="restrictionType"
            optionLabel="label"
            placeholder="Select Restriction type...">
          </p-dropdown>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Lock Asset</label>
          <div>
            <p-inputSwitch formControlName="lockAsset"></p-inputSwitch>
          </div>
        </div>
        <p *ngIf="asset?.locked"> <i class="fas fa-exclamation-triangle"></i> This option is not available, the asset is currently locked</p>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="onAddRestrictionFormSubmit()" [disabled]="!addAssetRestrictionForm.valid || isSaving" class="my-2 btn btn-round btn-sm btn-success">Add Restriction</button>
    <button type="button" (click)="isAddRestrictionModalShown = false" class="my-2 btn btn-round btn-sm btn-default">Cancel</button>
  </p-footer>
</p-dialog>
